import React, { useState, useEffect } from "react";
import { FaSave, FaTimes } from "react-icons/fa";
import { updateAdherentPret } from "../../../services/adherentpretServices";
import Button from "../../../components/Button/Button";
import { toast } from "react-toastify";
import moment from "moment";

const EditAdherentPretModal = ({ isOpen, onClose, pret, refreshList }) => {
  const [formData, setFormData] = useState({
    date_remise: "",
    note_pret: "",
  });

  useEffect(() => {
    if (pret) {
      setFormData({
        date_remise: pret.date_remise
          ? moment(pret.date_remise).format("YYYY-MM-DD")
          : "",
        note_pret: pret.note_pret || "",
      });
    }
  }, [pret]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await updateAdherentPret(pret.id, formData);
      toast.success("Prêt mis à jour avec succès");
      refreshList();
      onClose();
    } catch (error) {
      console.error("Erreur lors de la mise à jour du prêt", error);
      toast.error("Erreur lors de la mise à jour");
    }
  };

  if (!isOpen || !pret) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="modal-box bg-white p-4 rounded-lg shadow-lg w-full max-w-lg">
        <h3 className="text-xl font-bold uppercase p-3 mb-4 text-center text-white bg-primary rounded-md shadow">
          Modifier le prêt
        </h3>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <p className="text-sm font-bold">
              Adhérent : {pret.adherent?.prenom} {pret.adherent?.nom}
            </p>
            <p className="text-sm font-bold">Matériel : {pret.article?.nom}</p>
            <p className="text-sm">
              Date du prêt :{" "}
              {moment(pret.date_pret).isValid()
                ? moment(pret.date_pret).format("DD/MM/YY")
                : "Inconnue"}
            </p>
          </div>

          <input
            type="date"
            name="date_remise"
            value={formData.date_remise}
            onChange={handleChange}
            className="input input-bordered w-full mb-3"
            placeholder="Date de remise"
          />

          <input
            type="text"
            name="note_pret"
            placeholder="Note"
            value={formData.note_pret}
            onChange={handleChange}
            className="input input-bordered w-full mb-3"
          />

          <div className="flex justify-center space-x-2 mt-4">
            <Button text="Enregistrer" icon={FaSave} type="submit" className="btn-primary gap-2" />
            <Button text="Annuler" icon={FaTimes} onClick={onClose} type="button" className="btn-ghost gap-2" />
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditAdherentPretModal;
